// extracted by mini-css-extract-plugin
module.exports = {"markets":"appgenerica_markets__T6SHu"};